<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'stock-take-list'"
    ref="stock-take-list"
    :setLoading="setLoading"
    v-if="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { StockTakeListService } from "../../_services/api/inventory/stock-take-list.service";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Stocktakes",
        ScreenName: "Stocktakes",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "StocktakeList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "Code",
                "Type",
                "CountDate",
                "CommittedDate",
                "CommittedBy",
                "FriendlyStatus",
                "CreatedBy",
                "DateCreated",
                "StockAdjustmentCode",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Stocktakes",
                message: "Get Started, Add a Stocktake",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/stock-take-prepare/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "StocktakeManagement",
                  "create",
                ),
              },
            ],
            filterOnEnter: true,
          },
          columns: [
            {
              screenField: "Code",
              label: "Run Number",
              filterLabel: "Stocktake Run",
              type: "Integer",
              filterIndex: 0,
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
            },
            {
              screenField: "Product",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 2,
              filterDataField: "ItemCodeList",
              filterOperator: "contains",
            },
            {
              screenField: "DateIn",
              gridDataField: "CountDate",
              filterDataField: "CountDate",
              label: "Count Date",
              filterLabel: "Count Date",
              filterIndex: 3,
            },
            {
              screenField: "DateIn",
              gridDataField: "CommittedDate",
              filterDataField: "CommittedDate",
              label: "Date Committed",
              filterLabel: "Committed Date",
              filterIndex: 4,
            },
            {
              screenField: "Code",
              gridDataField: "StockAdjustmentCode",
              filterDataField: "StockAdjustmentCode",
              label: "Adjustment",
              hyperlink: {
                url: "stock-adjustment-v2/review/__ID__",
                target: "_blank",
              },
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              filterLabel: "Adjustment",
              type: "Integer",
              filterIndex: 1,
            },
            {
              screenField: "DateCreated",
            },
            {
              screenField: "CreatedBy",
              filterIndex: 5,
              allowHiding: false,
              dataSourceConfig: {
                endpoint: "api/Users",
                sort: {
                  selector: "Username",
                  asc: true,
                },
              },
            },
            {
              screenField: "CreatedBy",
              dataField: "CommittedBy",
              label: "Committed By",
              filterLabel: "Committed By",
              filterIndex: 6,
              allowHiding: false,
              filterDataField: "CommittedBy",
              dataSourceConfig: {
                endpoint: "api/Users",
                sort: {
                  selector: "Username",
                  asc: true,
                },
              },
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 7,
              dataSourceConfig: {
                data: ["Cancelled", "Completed", "In Progress"],
              },
            },

            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },

            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Commit",
                      data: data,
                      clickAction: this.commitStockTake,
                      disabled: !FeatureStorage.checkPermission(
                        "StocktakeManagement",
                        "create",
                      ),
                    },
                    {
                      menuText: "Cancel",
                      data: data,
                      clickAction: this.cancelStockTake,
                      disabled: !FeatureStorage.checkPermission(
                        "StocktakeManagement",
                        "create",
                      ),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (data) return data.data.FriendlyStatus != "In Progress";
                else return true;
              },
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    async commitStockTake(data) {
      let confirmCommit = await this.$confirm(
        `Are you sure you would like to commit this Stocktake?`,
        "Commit Stocktake",
      );

      if (confirmCommit) {
        let payload = { Code: data.Code };

        await StockTakeListService.commitStockTake(payload);
        this.$refs["stock-take-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      }
    },
    async cancelStockTake(data) {
      let confirmCancel = await this.$confirm(
        `Are you sure you would like to cancel this Stocktake?`,
        "Cancel Stocktake",
      );

      if (confirmCancel) {
        let payload = { Code: data.Code };

        await StockTakeListService.cancelStockTake(payload);
        this.$refs["stock-take-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      }
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.dataField !== "StockAdjustmentCode" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        if (
          e.data.FriendlyStatus === "Completed" ||
          e.data.FriendlyStatus === "Cancelled"
        ) {
          this.$router.push({
            path: `/stock-take-review/review/${e.data.Code}`,
          });
        } else if (e.data.FriendlyStatus === "In Progress") {
          if (FeatureStorage.checkPermission("StocktakeCount", "create")) {
            this.$router.push({
              path: `/stock-take-count/edit/${e.data.Code}`,
            });
          } else if (
            FeatureStorage.checkPermission("StocktakeManagement", "review") ||
            FeatureStorage.checkPermission("StocktakeCount", "review")
          ) {
            this.$router.push({
              path: `/stock-take-review/review/${e.data.Code}`,
            });
          }
        }
        // else if (e.data.FriendlyStatus !== "Cancelled") {
        //   this.$router.push({
        //     path: `/stock-take/count/${e.data.Code}`,
        //   });
        // }
      }
    },
  },

  created() {
    this.setLoading = true;
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
